import { useEffect, useState } from "react";
import api from "@/admin/api";
import { Eyebrow } from "@/components/comiq/Eyebrow";
import { COLORS } from "@/comiq/tokens";

export default function Audit() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/admin/audit?limit=200").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div className="p-6">
      <Eyebrow>Jejak Aktivitas</Eyebrow>
      <h1 className="font-serif-editorial mt-1 text-3xl" style={{ color: COLORS.ink }}>Audit log</h1>
      <p className="mt-1 text-sm" style={{ color: COLORS.textSoft }}>Setiap login, perubahan data, status gelombang, dan tindakan undangan tercatat.</p>

      <div className="mt-6 overflow-hidden rounded-comiq border bg-comiq-surface-alt" style={{ borderColor: COLORS.line }}>
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead>
              <tr style={{ background: COLORS.surface, color: COLORS.textSoft }}>
                {["Waktu", "Aktor", "Aksi", "Entitas", "Detail"].map((h) => (
                  <th key={h} className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {events.length === 0 && (
                <tr><td colSpan={5} className="px-4 py-8 text-center text-sm" style={{ color: COLORS.textSoft }}>Belum ada aktivitas.</td></tr>
              )}
              {events.map((e) => (
                <tr key={e.event_id} className="border-t align-top" style={{ borderColor: COLORS.line }}>
                  <td className="whitespace-nowrap px-4 py-3 text-xs" style={{ color: COLORS.textSoft }}>{new Date(e.created_at).toLocaleString("id-ID")}</td>
                  <td className="px-4 py-3 text-xs" style={{ color: COLORS.ink }}>{e.actor_email}</td>
                  <td className="px-4 py-3"><span className="rounded-full px-2 py-0.5 font-mono text-[11px] font-semibold" style={{ background: COLORS.paper, color: COLORS.ink }}>{e.action}</span></td>
                  <td className="px-4 py-3 text-xs" style={{ color: COLORS.textSoft }}>{e.entity_type ? `${e.entity_type}:${(e.entity_id || "").slice(-6)}` : "—"}</td>
                  <td className="max-w-xs px-4 py-3 font-mono text-[11px]" style={{ color: COLORS.textSoft }}>{Object.keys(e.detail || {}).length ? JSON.stringify(e.detail) : "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
